import e from "react";

var o = function o(_ref) {
  var i = _ref.className,
      l = _ref.svgPrefix;
  return e.createElement("svg", {
    width: "30",
    height: "18",
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i
  }, e.createElement("path", {
    id: "".concat(l, "-line1"),
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4L26 4V6L4 6V4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    id: "".concat(l, "-line2"),
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12L26 12V14L4 14V12Z",
    fill: "currentColor"
  }));
};

export { o as TriggerIcon };